import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3906a70e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer-content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-title"
}, [/*#__PURE__*/_createElementVNode("label", null, "产品服务")], -1));
const _hoisted_3 = {
  class: "product"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-title"
}, [/*#__PURE__*/_createElementVNode("label", null, "解决方案")], -1));
const _hoisted_5 = {
  class: "project"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-title"
}, [/*#__PURE__*/_createElementVNode("label", null, "关于我们")], -1));
const _hoisted_7 = {
  class: "us"
};
const _hoisted_8 = {
  class: "link-us"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo-title"
}, "安徽达链物流科技有限公司", -1));
const _hoisted_10 = {
  class: "hot-link"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " 7*24小时客服热线：", -1));
const _hoisted_12 = {
  class: "tel"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "copy-right"
}, [/*#__PURE__*/_createElementVNode("label", null, [/*#__PURE__*/_createTextVNode("Copyright©2026, huodada.com All Rights Reserved."), /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/#/Integrated/index"
}, " 皖ICP备2026037048号-1"), /*#__PURE__*/_createElementVNode("a", {
  class: "police-record",
  href: "https://beian.mps.gov.cn/#/query/webSearch?code=34080202003402"
}, " 皖公网安备34080202003402号")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_divider = _resolveComponent("a-divider");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("ul", _hoisted_3, [_createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[0] || (_cache[0] = $event => _ctx.goLink('/freight'))
  }, "数字货运")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[1] || (_cache[1] = $event => _ctx.goLink('/product'))
  }, "数字供应链")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[2] || (_cache[2] = $event => _ctx.goLink('/figureEnertgy'))
  }, "数字能源")])]), _hoisted_4, _createElementVNode("ul", _hoisted_5, [_createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[3] || (_cache[3] = $event => _ctx.goLink('/coal'))
  }, "煤炭行业")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[4] || (_cache[4] = $event => _ctx.goLink('/power'))
  }, "电力行业")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[5] || (_cache[5] = $event => _ctx.goLink('/chemical'))
  }, "化工行业")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[6] || (_cache[6] = $event => _ctx.goLink('/rail'))
  }, "铁路货站")])]), _hoisted_6, _createElementVNode("ul", _hoisted_7, [_createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[7] || (_cache[7] = $event => _ctx.goLink('/aboutHuoda'))
  }, "关于我们")])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_a_divider, {
    class: "divider"
  }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaSchema, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["wx-current-media", {
        active: item.type === _ctx.currentMedialName
      }])
    }, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("label", _hoisted_12, _toDisplayString(item.hotline), 1)])], 2);
  }), 256))]), _hoisted_13]);
}